import 'bootstrap';
import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';

export default class extends Controller {
  static targets = ['trigger'];

  connect() {
    $.fn.modal.Constructor.Default.backdrop = 'static';
    const self = this;
    self.initializeModals();
    $('body').on('ajax-content-loaded', () => {
      self.initializeModals();
    });
  }

  initializeModals() {
    this.triggerTargets.forEach((el) => {
      if ($(el).data('initialized') !== 'true') {
        const modalSel = $(el).data('modal-selector');
        $(el).on('click', () => {
          $(modalSel).modal('show');
        });
        $(el).data('initialized', 'true');
      }
    });
  }
}
